/**
 * Test ID utilities for roaster list component
 */
import { generateTestId } from "@client-shared";

const base = "RoasterList";

export const setRoasterListTestId = (identifier: string): string => generateTestId(base, identifier);

export const setImpersonateButtonTestId = (roasterId: string): string => generateTestId(base, "impersonate-button", roasterId);
